CreateCrmContactController.$inject = [
  '$scope',
  '$translate',
  '$mdDialog',
  '$stateParams',
  'CrmFactory',
  'AlertingFactory',
  'companyId',
  'organization',
  'groupName',
];
export function CreateCrmContactController(
  $scope,
  $translate,
  $mdDialog,
  $stateParams,
  CrmFactory,
  AlertingFactory,
  companyId,
  organization,
  groupName
) {
  $scope.submit = submit;
  $scope.cancel = cancel;
  init();

  function submit() {
    let newCrmContact = {};
    organization.configuration.contact_creation_entries.forEach((entry) => {
      newCrmContact[entry.field_name] = entry.field_value;
    });

    CrmFactory.createCrmContact(
      companyId,
      organization.id,
      newCrmContact
    ).then(
      (response) => {
        $mdDialog.hide(response.data.created_crm_contact);
      },
      (response) => {
        let contactCreationErrorDetails = response.data.error.reason.details;
        if (
          contactCreationErrorDetails.email &&
          contactCreationErrorDetails.email[0].error === 'DuplicateValue'
        ) {
          $scope.contactCreationErrorMsg =
            contactCreationErrorDetails.email[0].description;
        } else {
          $scope.contactCreationErrorMsg = contactCreationErrorDetails;
        }
      },
      (response) => CrmFactory.handleCrmErrors(response)
    );
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function init() {
    $scope.organization = organization;

    // As a convenience for the user, let's pre-fill user name form field
    let entry = organization.configuration.contact_creation_entries.find(
      (entry) => entry.field_name == 'name'
    );
    if (entry) {
      entry.field_value = groupName;
    }

    $scope.contactCreationErrorMsg = null;
  }
}
